function NoMatch() {
  return (
    <div className="not-found">
      <h2>404 Not Found</h2>
    </div>
  );
}

export default NoMatch;
